import { createAsyncThunk } from '@reduxjs/toolkit';
import ApiService from '../../../infrastructure/services/api/services';
import { apiConfig } from '../../../application/configurations/apiConfig';
import { ApiConfig } from '../../../application/configurations/IConfig';

/**
 * class for processing async functions based on actions
 */
class Insights {
    private insightApiConfig: ApiConfig;

    constructor() {
        this.insightApiConfig = { ...apiConfig.insightsfeedback };
    }

    /**
   * async method with redux store middleware Thunk wrapper
   * this is used to access the action based api configuration and
   * add dynamic params then send to http request service.
   * this is also pass the response to
   * @param   {object} request the request object containing search query term & an optional start row.
   * @return  {object} return api response
   */
    captureInsightsFeedback = createAsyncThunk(
        'insightsfeedback',
        async(
            request: {
                title: string;
                url: string;
                location: string;
                userFeedback: string;
                searchTerm: string;
                comments: string;
            },
            thunkApi
        ) => {
            let responseData: any = [];
            const insightApiConfig = { ...this.insightApiConfig };
            insightApiConfig.data = {
                ...insightApiConfig.data,
                title: request.title,
                url: request.url,
                location: request.location,
                userFeedback:  request.userFeedback,
                searchTerm: request.searchTerm,
                comments: request.comments
            }
            await ApiService.requestApi([insightApiConfig])
            .then(
                (response: { [key: string]: any }) => {
                    responseData = response;
                }
            )

            return {
                response: responseData
            }
        }
    )
}

const InsightsUseCase = new Insights();
export default InsightsUseCase;